import type {
  CreateLotteryBody,
  CreateLotteryParams,
  CreateLotteryResponse,
  DeleteLotteryParams,
  GetLotteriesParams,
  GetLotteriesResponse,
  GetLotteryParams,
  GetTranslationsParams,
  GetTranslationsResponse,
  UpdateLotteryParams,
  UpdateLotteryResponse,
  StopLotteryParams,
  GetLotteryResponse,
} from '@lotta/shared/types-lottery-api';
import { apis } from './apis';

const lotteryApis = apis.injectEndpoints({
  endpoints: (build) => ({
    getLotteries: build.query<GetLotteriesResponse, GetLotteriesParams['retailUnit']>({
      query: (retailUnit: string) => `/${retailUnit}/lottery`,
      providesTags: ['Lottery'],
    }),
    getLottery: build.query<GetLotteryResponse, GetLotteryParams>({
      query: ({ retailUnit, lotteryId }) => `/${retailUnit}/lottery/${lotteryId}`,
      providesTags: ['Lottery'],
    }),
    getLotteryTranslations: build.query<GetTranslationsResponse, GetTranslationsParams>({
      query: ({ retailUnit, lotteryId }) => `/${retailUnit}/lottery/${lotteryId}/translations`,
      providesTags: ['Lottery'],
    }),
    createLottery: build.mutation<CreateLotteryResponse, CreateLotteryParams & CreateLotteryBody>({
      query: ({ retailUnit, lottery, translation }) => ({
        url: `/${retailUnit}/lottery`,
        method: 'POST',
        body: { lottery, translation },
      }),
      invalidatesTags: ['Lottery'],
    }),
    updateLottery: build.mutation<UpdateLotteryResponse, UpdateLotteryParams & CreateLotteryBody>({
      query: ({ retailUnit, lotteryId, lottery, translation }) => ({
        url: `/${retailUnit}/lottery/${lotteryId}`,
        method: 'PUT',
        body: { lottery, translation },
      }),
      invalidatesTags: ['Lottery'],
    }),
    deleteLottery: build.mutation<unknown, DeleteLotteryParams>({
      query: ({ retailUnit, lotteryId }) => ({
        url: `/${retailUnit}/lottery/${lotteryId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Lottery'],
    }),
    stopLottery: build.mutation<unknown, StopLotteryParams>({
      query: ({ retailUnit, lotteryId }) => ({
        url: `/${retailUnit}/lottery/stop/${lotteryId}`,
        method: 'POST',
      }),
      invalidatesTags: ['Lottery'],
    }),
  }),
});

export const {
  useGetLotteriesQuery,
  useGetLotteryQuery,
  useGetLotteryTranslationsQuery,
  useCreateLotteryMutation,
  useUpdateLotteryMutation,
  useDeleteLotteryMutation,
  useStopLotteryMutation,
} = lotteryApis;
